import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { BannerOutputDto, BannerService, CityService } from 'src/generated_client';

@Component({
  selector: 'app-banners-management',
  templateUrl: './banners-management.component.html',
  styleUrls: ['./banners-management.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class BannersManagementComponent implements OnInit {

  displayedColumns: string[] = ['city', 'image', 'position', 'status', 'option'];
  allBaners: BannerOutputDto[] = [];


  constructor(
    private router: Router,
    private snackBar: SnackBarService,
    public bannerService: BannerService,
    public cityService: CityService
  ) {
  }

  ngOnInit() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.bannerService.apiBannerGetAllGet().subscribe(banners => {
      this.allBaners = banners;
    })
  }

  changeBannerStatus(id: number, status: boolean) {
    this.bannerService.apiBannerPutStatePut(id, !status).subscribe(response => {
      this.router.navigate(['banners-management']);
      this.snackBar.openSnackBar('Se cambió el estado correctamente','Aceptar')
    }, error => {
      this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse.', 'Aceptar')
    })
  }

  deleteBanner(id: number) {
    this.bannerService.apiBannerDeleteDelete(id).subscribe(response => {
      this.router.navigate(['banners-management']);
      this.snackBar.openSnackBar('El banner fue eliminado', 'Aceptar')
    }, error => {
      this.snackBar.openSnackBar('Ocurrió un error y el banner no pudo eliminarse.', 'Aceptar')
    })
  }

  editBanner(id: number) {
    this.router.navigate(['edit-banner', id]);
  }

  addBanner() {
    this.router.navigate(['add-banner']);
  }

}
